<template>
  <div class='noPage' style='height: 100%;'>
    <ejs-grid ref='grid' :dataSource='data' height='calc(100% - 0px)' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :dataBound='dataBoundFunc'>
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='10%'></e-column>
        <e-column field='alarmId' :headerText='$t("Alarm.alarmID")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmType' :headerText='$t("Alarm.alarmType")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='typeFormat'></e-column>
        <e-column field='level' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='neType' :headerText='$t("Pm.ne_type_id")' textAlign='Left' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'alarmTable',
  provide: {
    grid: [Reorder, Resize]
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      alarmListCache: {}, // 缓存选中的alarmID
      // alarmDataCache: {}, // 缓存选中的数据
      currentDataList: [], // 缓存当前操作的值
      queryConditions: {
        systemId: '',
        neTypeList: [],
        alarmLevelList: [],
        alarmID: '',
        alarmName: '',
      },
      data: [],
      clearStatus: false
    };
  },
  methods: {
    typeFormat(grids, data) {
      if (data.alarmType || data.alarmType === 0) {
        return this.$t(`Alarm.alarmType_${data.alarmType}`);
      }
      return '';
    },
    levelFormat(grids, data) {
      if (data.level || data.level === 0) {
        return this.$t(`Alarm.alarmLevel_${data.level}`);
      }
      return '';
    },
    dataBoundFunc() {
      const selectRowIndexList = [];
      Object.entries(this.alarmListCache).forEach((value) => {
        if (value[1] === true) {
          const index = this.data.findIndex(v => v.alarmId+'-'+v.neType == value[0]);
          if (index > -1) {
            selectRowIndexList.push(index);
          }
        }
      });
      this.$refs.grid.selectRows(selectRowIndexList);
    },
    actionComplete() {
      this.$refs.grid.selectRow(0,true);
      this.$refs.grid.selectRow(0,true);
    },
    // checkBoxChangeFunc(args) {
    //   for (let i = 0; i < this.currentDataList.length; i++) {
    //     this.alarmListCache[this.currentDataList[i].alarmid] = args.checked;
    //   }
    // },
    // rowSelected(args) {
    //   this.currentDataList = [];
    //   if (args.data instanceof Array) {
    //     for (let i = 0; i < args.data.length; i++) {
    //       this.currentDataList.push(args.data[i]);
    //       this.alarmDataCache[args.data[i].alarmid] = args.data[i];
    //     }
    //   } else {
    //     if (args.data && args.data.alarmid) {
    //       this.currentDataList.push(args.data);
    //       this.alarmDataCache[args.data.alarmid] = args.data;
    //     }
    //   }
    //
    // },
    // rowDeselected(args) {
    //   this.currentDataList = [];
    //   for (let i = 0; i < args.data.length; i++) {
    //     this.currentDataList.push(args.data[i]);
    //   }
    // },
    clearCache() {
      // this.clearStatus = true;
      this.alarmListCache = {};
      // this.alarmDataCache = {};
      this.queryConditions = {
        systemId: '',
        neTypeList: [],
        alarmLevelList: []
      };
      this.getAlarmTableData();
    },
    getCheckedData() {
      // const returnList = [];
      // Object.entries(this.alarmListCache).forEach((value) => {
      //   if (value[1] === true) {
      //     returnList.push(this.alarmDataCache[value[0]]);
      //   }
      // });
      return this.$refs.grid.getSelectedRecords();
    },
    getAlarmTableData() {
      const This = this;
      const level = [];
      for (let i = 0; i < This.queryConditions.alarmLevelList.length; i++) {
        level.push(parseInt(This.queryConditions.alarmLevelList[i], 10));
      }
      // const alarmId = This.queryConditions.alarmID;
      // if(alarmId == "") {
      //   This.queryConditions.alarmID = "-1";
      // }
      // 默认查enodeb
      if (This.queryConditions.neTypeList.length < 1) {
        This.queryConditions.neTypeList = ["10004"];
      }
      This.$axios.post('/lte/ems/fm/filter/queryalarm', {
        levelList: level,
        neTypeList: This.queryConditions.neTypeList,
        alarmId: This.queryConditions.alarmID,
        alarmName: This.queryConditions.alarmName
      }).then((response) => {
        if (response && response.status === 200) {
          for (let i = 0; i < response.data.resultVal.length; i++){//NM8000-8316 NM8000-8318
            response.data.resultVal[i].neType = response.data.resultVal[i].neType.toUpperCase();
          }
          This.data = response.data.resultVal;
          // if (This.clearStatus === true) {
          //   Object.entries(This.alarmListCache).forEach((value) => {
          //     if (value[1] === true) {
          //       const index = this.data.findIndex(v => v.alarmid === parseInt(value[0], 10));
          //       if (index > -1) {
          //         This.alarmDataCache[value[0]] = this.data[index];
          //       }
          //     }
          //   });
          // }
          // This.clearStatus = false;
        }
      });
    }
  }
};
</script>
